import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { fetchJobs } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import ReactMarkdown from 'react-markdown';
import Helmet from 'react-helmet';

import '../components/Jobs.css'

class JobPage extends Component {

  componentDidMount()
  {
    if (!this.props.jobs.fields) {
      this.props.fetchJobs(this.props.intl.locale);
    }
  }

  render() {
    const {jobs} = {...this.props};
    const slug = this.props.match.params.slug;

    let job;

    if(slug) {
      job = jobs.find((p) => {
        return p.fields.slug === this.props.match.params.slug;
      })
    }

    return (
      <div className="jobs">
        {!jobs && <Loader/>}
        {(jobs && job) && 
          <div key={job.sys.id} className="content-block single job">
          <Helmet>
            <title>{job.fields.jobTitle}</title>
          </Helmet>
            <div className="container">
              <div>
                {job.fields.jobTitle && <h1>{job.fields.jobTitle}</h1>}
                {job.fields.location && <p className="location">{job.fields.location}</p>}
                {job.fields.jobDescription && <ReactMarkdown source={job.fields.jobDescription} softBreak="br" />}
                {job.fields.readMoreUrl && <a href={job.fields.readMoreUrl} className="readmore" target="_blank">{this.props.intl.messages["general.applyForJob"]}</a>}
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

JobPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  jobs: state.jobs
});

const mapDispatchToProps = {
  fetchJobs
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(JobPage));


// WEBPACK FOOTER //
// ./src/containers/JobPage.js